import {Dispatch, SetStateAction, useEffect} from "react";
import {ChevronDoubleLeft, ChevronDoubleRight, ChevronLeft, ChevronRight} from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";

interface PagerProps {
    itemCount : number
    currentPage : number
    setCurrentPage? : Dispatch<SetStateAction<number>>
    maxItemsPerPage : number
}

export const Pager = ({itemCount, currentPage, setCurrentPage, maxItemsPerPage} : PagerProps) =>
{
    // there should always be one page even if there are no items
    const nrOfPages = Math.max(1, Math.ceil(itemCount / maxItemsPerPage));

    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    useEffect(() =>
    {
        // can happen that items were deleted and that there are now less pages
        if (setCurrentPage !== undefined && currentPage > nrOfPages) {
            setCurrentPage(nrOfPages);
        }
    }, [currentPage, nrOfPages, setCurrentPage]);

    const onChangePage = (newPage: number) =>
    {
        // if page nr is invalid, do nothing
        if (newPage < 1 || newPage > nrOfPages) {
            return
        }

        if (setCurrentPage !== undefined) {
            setCurrentPage(newPage);
        }
    }

    function getCurrentPage() : number{
        return  currentPage > nrOfPages ? nrOfPages : currentPage;
    }

    return (
        <>
            <Button className="p-0" variant="link" onClick={() => onChangePage(1)}>
                <ChevronDoubleLeft className="align-middle"/>
            </Button>
            <Button className="p-0" variant="link" onClick={() => onChangePage(getCurrentPage() - 1)} disabled={getCurrentPage() === 1}>
                <ChevronLeft/>
            </Button>
            <Form.Control className="w-auto"
                          type="number"
                          size="sm"
                          min={1}
                          max={nrOfPages}
                          value={getCurrentPage()}
                          onChange={e => onChangePage(Number(e.target.value))}
                          title={`Total number of rows ${itemCount}`}
            />
            <Button className="p-0" variant="link" onClick={() => onChangePage(getCurrentPage() + 1)} disabled={getCurrentPage() === nrOfPages}>
                <ChevronRight/>
            </Button>
            <Button className="p-0" variant="link" onClick={() => onChangePage(nrOfPages)}>
                <ChevronDoubleRight/>
            </Button>
            <Form.Text className="ms-2" muted>
                <small>{t("pager.page")} {getCurrentPage()} of {nrOfPages}</small>
            </Form.Text>
        </>
    )
}
